class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    this.addEventListener('click', (event) => {
      if (this.classList.contains('active') && !event.target.closest('.drawer__inner') && !event.target.closest('#cart-icon-bubble')) {
        this.close();
      }
    });

    this.setHeaderCartIconAccessibility();
    this.initCartNoteAnimation();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    const isCartPage = window.location.pathname === (window.routes ? window.routes.cart_url : '/cart') || window.location.pathname.endsWith('/cart');
    if (isCartPage) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    const isCartPage = window.location.pathname === (window.routes ? window.routes.cart_url : '/cart') || window.location.pathname.endsWith('/cart');
    if (isCartPage) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.initCartNoteAnimation();
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  initCartNoteAnimation() {
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary, .cart-drawer__note-summary');
    if (cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      if (!cartDrawerNote.hasAttribute('aria-expanded')) {
        cartDrawerNote.setAttribute('aria-expanded', 'false');
      }
    }

    if (this.noteAnimationInitialized) return;
    this.noteAnimationInitialized = true;

    this.addEventListener('click', (event) => {
      const summary = event.target.closest('.cart-drawer__note-summary, [id^="Details-"] summary');
      if (!summary) return;

      event.preventDefault();
      event.stopPropagation();

      const details = summary.closest('details');
      const noteContent = summary.nextElementSibling;
      if (!details || !noteContent) return;

      const isOpen = details.hasAttribute('open');

      if (isOpen) {
        // Smooth Close Animation
        summary.setAttribute('aria-expanded', 'false');
        details.classList.remove('is-open');
        const startHeight = noteContent.scrollHeight;
        
        noteContent.style.height = `${startHeight}px`;
        noteContent.style.overflow = 'hidden';
        noteContent.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease, margin-top 0.35s ease';
        
        requestAnimationFrame(() => {
          noteContent.style.height = '0px';
          noteContent.style.opacity = '0';
          noteContent.style.marginTop = '0px';
        });

        setTimeout(() => {
          details.removeAttribute('open');
          noteContent.style.cssText = '';
        }, 350);
      } else {
        // Smooth Open Animation
        summary.setAttribute('aria-expanded', 'true');
        details.setAttribute('open', '');
        details.classList.add('is-open');

        noteContent.style.display = 'block';
        noteContent.style.overflow = 'hidden';
        const targetHeight = noteContent.scrollHeight;

        noteContent.style.height = '0px';
        noteContent.style.opacity = '0';
        noteContent.style.marginTop = '0px';
        noteContent.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s ease, margin-top 0.35s ease';

        requestAnimationFrame(() => {
          noteContent.style.height = `${targetHeight}px`;
          noteContent.style.opacity = '1';
          noteContent.style.marginTop = '12px';
        });

        setTimeout(() => {
          noteContent.style.height = 'auto';
          noteContent.style.overflow = '';
        }, 350);
      }
    });
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
